<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
  >
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card
          color="#3364FF"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Avancée des séries
            </div>

            <div class="subtitle-1 font-weight-light">
              Ci-dessous le dernier épisode de chaque série présente sur Plex
            </div>
          </template>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Rechercher une série"
              single-line
              hide-details
              class="px-5 py-5"
            />
          </v-card-title>
          <v-card-text>
            <v-data-table
              v-model="selected"
              :headers="headers"
              :items="items"
              :items-per-page="10"
              :search="search"
              :loading="loading"
              loading-text="Chargement des données"
              no-data-text="Aucune donnée"
              no-results-text="Aucun résultat"
              :footer-props="{
                itemsPerPageAllText: 'Tous',
                itemsPerPageText: 'Lignes par page',
                showCurrentPage: true,
              }"
            >
              <template #footer.page-text="props">
                {{ props.pageStart }}-{{ props.pageStop }} de {{ props.itemsLength }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  class="ma-2"
                  dark
                  @click="downloadNextEpisodeSS(item)"
                >
                  {{ item.nextEpisodeSameSeason }}
                  <v-icon
                    dark
                    right
                    small
                    class="mr-2"
                  >
                    mdi-download
                  </v-icon>
                </v-btn>
                <v-btn
                  class="ma-2"
                  dark
                  @click="downloadNextEpisodeNS(item)"
                >
                  {{ item.nextEpisodeNextSeason }}
                  <v-icon
                    dark
                    right
                    small
                    class="mr-2"
                  >
                    mdi-download
                  </v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { axios } from '@/plugins/axios'

  export default {
    data: () => ({
      token: '',
      url: process.env.VUE_APP_API_URL,
      selected: [],
      search: '',
      loading: true,
      headers: [
        {
          sortable: true,
          text: 'Nom sur Plex',
          value: 'name',
          width: '10%',
        },
        {
          sortable: true,
          text: 'Nom dans les fichiers',
          value: 'physicName',
          width: '10%',
        },
        {
          sortable: false,
          text: 'Dernier episode',
          value: 'episode',
          align: 'center',
          width: '5%',
        },
        {
          text: 'Télécharger le prochain épisode',
          value: 'action',
          sortable: false,
          align: 'center',
          width: '15%',
        },
      ],
      items: [],
    }),
    mounted () {
      if (this.isAuth()) {
        this.getDatas()
      }
    },
    methods: {
      isAuth () {
        if (this.$cookie.get('token')) {
          this.token = this.$cookie.get('token')
          return true
        } else {
          this.$router.push('SignIn')
          return false
        }
      },
      getDatas () {
        /* eslint handle-callback-err: "error" */
        axios.get(this.url + '/Plex/Shows/GetLastEpisodes', { headers: { token: this.$cookie.get('token') } }).then(response => {
          /* eslint-disable no-unused-vars */
          for (const [key, value] of Object.entries(response.data)) {
            this.items.push(value)
          }
          this.loading = false
        })
      },
      downloadNextEpisodeSS (item) {
        this.$router.push({ name: 'Télécharger', params: { src: 'shows', content: item.nextEpisodeSameSeason, showname: item.physicName } })
      },
      downloadNextEpisodeNS (item) {
        this.$router.push({ name: 'Télécharger', params: { src: 'shows', content: item.nextEpisodeNextSeason, showname: item.physicName } })
      },
    },
  }
</script>
